import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Layout from './Layout';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft, FiMusic } = FiIcons;

const NotFoundPage = () => {
  const { language } = useLanguage();
  const isChinese = language === 'zh';

  return (
    <Layout>
      <Helmet>
        <title>
          {isChinese
            ? '找不到頁面｜Beat Buddy 互動式音樂節拍器'
            : 'Page Not Found | Beat Buddy Metronome'}
        </title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>

      <section className="mx-auto max-w-2xl rounded-3xl bg-white p-8 text-center shadow-xl dark:bg-gray-800 sm:p-12">
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-purple-500 to-pink-500 text-white shadow-lg">
          <SafeIcon icon={FiMusic} className="h-9 w-9" />
        </div>

        <p className="mb-2 text-sm font-bold uppercase tracking-[0.3em] text-purple-600 dark:text-purple-400">
          404
        </p>
        <h2 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl">
          {isChinese ? '這個頁面走失了' : 'This page missed the beat'}
        </h2>
        <p className="mx-auto mt-4 max-w-md leading-relaxed text-gray-600 dark:text-gray-300">
          {isChinese
            ? '您要尋找的頁面可能已移動、重新命名或不存在。返回首頁即可繼續節拍練習。'
            : 'The page may have moved, been renamed, or no longer exists. Return home to continue your rhythm practice.'}
        </p>

        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 px-6 py-3 font-bold text-white shadow-md transition-all duration-200 hover:scale-105 hover:shadow-lg"
        >
          <SafeIcon icon={FiArrowLeft} className="h-4 w-4" />
          {isChinese ? '返回 Beat Buddy 首頁' : 'Return to Beat Buddy'}
        </Link>
      </section>
    </Layout>
  );
};

export default NotFoundPage;